(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quick-add-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    var overlay = document.querySelector('[data-qa-overlay]');
    var drawer = document.querySelector('[data-qa-drawer]');
    if (!overlay || !drawer) return;

    var closeBtn = drawer.querySelector('[data-qa-close]');
    var loadingEl = drawer.querySelector('[data-qa-loading]');
    var contentEl = drawer.querySelector('[data-qa-content]');
    var imagesEl = drawer.querySelector('[data-qa-images]');
    var vendorEl = drawer.querySelector('[data-qa-vendor]');
    var titleEl = drawer.querySelector('[data-qa-title]');
    var priceEl = drawer.querySelector('[data-qa-price]');
    var optionsEl = drawer.querySelector('[data-qa-options]');
    var atcBtn = drawer.querySelector('[data-qa-atc]');
    var buyNowBtn = drawer.querySelector('[data-qa-buy-now]');

    var currentProduct = null;
    var currentVariantId = null;
    var currentProductUrl = null;
    var productCache = {};

    function openDrawer() {
      drawer.setAttribute('aria-hidden', 'false');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      drawer.setAttribute('aria-hidden', 'true');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function showLoading() {
      loadingEl.setAttribute('aria-hidden', 'false');
      contentEl.hidden = true;
    }

    function showContent() {
      loadingEl.setAttribute('aria-hidden', 'true');
      contentEl.hidden = false;
    }

    function formatMoney(cents) {
      var dollars = Math.floor(cents / 100);
      var remainder = cents % 100;
      if (remainder === 0) return dollars + ' USD';
      return (cents / 100).toFixed(2) + ' USD';
    }

    function findVariant(product, selectedOptions) {
      return product.variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return opt === selectedOptions[i];
        });
      }) || null;
    }

    function getSelectedOptions() {
      var opts = [];
      optionsEl.querySelectorAll('.qa-option-group').forEach(function (group) {
        var selected = group.querySelector('.qa-pill.is-selected');
        opts.push(selected ? selected.getAttribute('data-value') : null);
      });
      return opts;
    }

    function updateVariantState() {
      if (!currentProduct) return;
      var selectedOpts = getSelectedOptions();
      var allSelected = selectedOpts.every(function (o) { return o !== null; });

      if (allSelected) {
        var variant = findVariant(currentProduct, selectedOpts);
        currentVariantId = variant ? variant.id : null;
        var available = variant ? variant.available : false;
        atcBtn.disabled = !available;
        buyNowBtn.disabled = !available;
        atcBtn.textContent = available ? 'Agregar al carrito' : 'Sin stock';
      } else {
        currentVariantId = null;
        atcBtn.disabled = true;
        buyNowBtn.disabled = true;
        atcBtn.textContent = 'Agregar al carrito';
      }

      // Update pill availability per option group
      var groups = optionsEl.querySelectorAll('.qa-option-group');
      groups.forEach(function (group, groupIndex) {
        group.querySelectorAll('.qa-pill').forEach(function (pill) {
          var testOpts = selectedOpts.slice();
          testOpts[groupIndex] = pill.getAttribute('data-value');
          var hasStock = currentProduct.variants.some(function (v) {
            return v.available && v.options.every(function (opt, i) {
              return testOpts[i] === null || opt === testOpts[i];
            });
          });
          pill.disabled = !hasStock;
        });
      });
    }

    function renderProduct(product) {
      currentProduct = product;
      currentVariantId = null;

      // Images (show first 2)
      imagesEl.innerHTML = '';
      var imgs = product.images.slice(0, 2);
      if (imgs.length === 1) imagesEl.classList.add('qa-drawer__images--single');
      else imagesEl.classList.remove('qa-drawer__images--single');
      imgs.forEach(function (src) {
        var img = document.createElement('img');
        img.src = src;
        img.alt = product.title;
        img.loading = 'lazy';
        imagesEl.appendChild(img);
      });

      // Info
      vendorEl.textContent = product.vendor || '';
      vendorEl.hidden = !product.vendor;
      titleEl.textContent = product.title.toUpperCase();
      priceEl.textContent = formatMoney(product.price);

      // Options
      optionsEl.innerHTML = '';
      product.options.forEach(function (option, i) {
        var group = document.createElement('div');
        group.className = 'qa-option-group';
        group.setAttribute('data-option-index', i);

        var label = document.createElement('label');
        label.className = 'qa-option-group__label';
        label.textContent = option.name.toUpperCase();
        var valueSpan = document.createElement('span');
        valueSpan.setAttribute('data-option-value-label', '');
        label.appendChild(valueSpan);
        group.appendChild(label);

        var pills = document.createElement('div');
        pills.className = 'qa-option-group__pills';

        option.values.forEach(function (value) {
          var pill = document.createElement('button');
          pill.type = 'button';
          pill.className = 'qa-pill';
          pill.textContent = value;
          pill.setAttribute('data-value', value);
          pill.addEventListener('click', function () {
            group.querySelectorAll('.qa-pill').forEach(function (p) { p.classList.remove('is-selected'); });
            pill.classList.add('is-selected');
            valueSpan.textContent = value;
            updateVariantState();
          });
          pills.appendChild(pill);
        });

        group.appendChild(pills);
        optionsEl.appendChild(group);
      });

      // Auto-select if only one option group with one value (single-option products)
      if (product.options.length === 1 && product.options[0].values.length === 1) {
        var firstPill = optionsEl.querySelector('.qa-pill');
        if (firstPill) firstPill.click();
      }

      atcBtn.disabled = true;
      buyNowBtn.disabled = true;
      atcBtn.textContent = 'Agregar al carrito';
      showContent();
    }

    function loadProduct(handle) {
      if (productCache[handle]) {
        renderProduct(productCache[handle]);
        return;
      }
      showLoading();
      fetch('/products/' + handle + '.js')
        .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
        .then(function (product) {
          productCache[handle] = product;
          renderProduct(product);
        })
        .catch(function () {
          closeDrawer();
          if (currentProductUrl) window.location.href = currentProductUrl;
        });
    }

    // ATC button
    atcBtn.addEventListener('click', function () {
      if (!currentVariantId) return;
      atcBtn.disabled = true;
      atcBtn.textContent = 'Agregando…';
      var body = JSON.stringify({ id: currentVariantId, quantity: 1 });
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: body
      })
        .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
        .then(function () {
          if (window.cartDrawer) return window.cartDrawer._fetchAndRender();
        })
        .then(function () {
          closeDrawer();
          if (window.cartDrawer) window.cartDrawer._openOnly();
        })
        .catch(function () {
          atcBtn.disabled = false;
          atcBtn.textContent = 'Agregar al carrito';
        });
    });

    // Buy Now button
    buyNowBtn.addEventListener('click', function () {
      if (!currentVariantId) return;
      window.location.href = '/cart/' + currentVariantId + ':1';
    });

    // Close handlers
    closeBtn.addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') closeDrawer();
    });

    // Global API
    window.quickAddDrawer = {
      open: function (handle, productUrl) {
        currentProductUrl = productUrl || null;
        openDrawer();
        loadProduct(handle);
      }
    };

    // Delegated listener for all [data-quick-add-multi] buttons
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quick-add-multi]');
      if (!btn) return;
      e.preventDefault();
      var handle = btn.getAttribute('data-product-handle');
      var url = btn.getAttribute('data-product-url');
      if (handle) {
        window.quickAddDrawer.open(handle, url);
      } else if (url) {
        window.location.href = url;
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["scroll-to-top-button"] && !Shopify.designMode) return;
  try {
    (function () {
    var btn = document.querySelector('.scroll-to-top');
    if (!btn) return;

    window.addEventListener('scroll', function () {
      if (window.scrollY > 300) {
        btn.classList.add('is-visible');
      } else {
        btn.classList.remove('is-visible');
      }
    }, { passive: true });

    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
